/**
 * nin: loadLanguageOnPage decorator
 * 
 */
 import React, {Component} from "react";
 import {loadLanguage} from '../config/i18nConfiguration';
 import Utils from '../../common/Utils';
 import { Redirect } from 'react-router-dom';
 import cookie from 'react-cookies';
 import AccountAction from '../../actions/AccountAction';
 import SameSite from "../../common/SameSite";
 import _ from 'lodash';
 export default function loadLanguageOnPage() {  
     return function(Child) {
       return class extends Component {
          constructor(props) {
           super(props);
            this.pageLoadLang(this.updateLanguageParam(props.match.params.lang), false); 
          }
          render() {
             const sportsArr = _.split(
               this.removeLastSlash(
                 this.props.location.pathname
               ), '/');
             const lastUrlPath = sportsArr[sportsArr.length - 1];
             const atHomePage = lastUrlPath == 'asian';
             const arcadiaCookieSuffix = `isArcadia${window.env.arcadiaCookieSuffix}`;
             if((atHomePage || sportsArr.includes('sports')) && cookie.load(arcadiaCookieSuffix)) {
               const sameSite = SameSite.isSameSiteCompatible ? ` secure=true; SameSite=None;` : ``;
               document.cookie = `${arcadiaCookieSuffix}=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/; domain=${AccountAction.getSubDomain()};${sameSite}`;
             }
             if(this.props.match.params.lang == null || this.props.match.params.lang === '') {               
                 let lang = Utils.getCurrentLang() || 'en'
 
                 return (
                     <Redirect to={`/${lang}/`} />
                 );
             }
             else{
                  return (
                     <Child {...this.props} />
                 )
           }
         }
         updateLanguageParam(lang) {
           const __udata = Utils.getUdata();
           const userLang = Utils.getUserLanguage();
           const defaultLanguage = Utils.getDefaultLanguageByBrand(
             !window.env.isB2B && __udata.auth && userLang !== lang
               ? userLang
               : lang);
           // update to pathname
           if (lang !== defaultLanguage) {
             const path = this.props.location.pathname.replace(`/${lang}`, `/${defaultLanguage}`);
             this.props.history.push(path);
           }
           return defaultLanguage;
         }
         pageLoadLang(lang, isFireEvent) {
           if (lang === null) return

           loadLanguage(lang, isFireEvent);
           //this.state = { currentLang: lang };
           document.body.classList.add(Utils.toLocaleCode(lang));
           document.documentElement.classList.add(Utils.toLocaleCode(lang));

         }
         removeLastSlash(path) {
           return path.replace(/(\/*)$/, "");
         }
         componentWillUpdate(nextProps, nextState) {
             let nextLang = nextProps.match.params.lang;
             let currentLang = this.props.match.params.lang;
             if(currentLang !== nextLang){
                 this.pageLoadLang(nextLang, true);
                 document.body.classList.remove(Utils.toLocaleCode(currentLang)); 
                 document.documentElement.classList.remove(Utils.toLocaleCode(currentLang));              
             }
         }
 
         componentDidUpdate(prevProps, prevState) {
              //window.fireEvent(EVENT.BODY_CENTER_LOADING_DONE)
         }
         
      }
  }
 }


// WEBPACK FOOTER //
// ./src/app/common/decorator/loadLanguageOnPage.js